export default __webpack_public_path__ + "365a1ba9db2a1a10960b2c130dde08b6.svg";